export const FIRST_PHASE = "firstPhase";
export const SECOND_PHASE = "secondPhase";
export const FINAL_PHASE = "finalPhase";
export const SPINNER_TIMEOUT_MILLIS = 35000;
export const SECOND_PHASE_MILLIS = 20000;
export const FINAL_PHASE_MILLIS = 0;
export const REDIRECT_TITLE_LABEL = "ais_redirecting";
export const REDIRECT_MESSAGE_LABEL = "ais_redirecting_bank";
export const REDIRECT_TIMEOUT_TITLE_LABEL = "ais_redirect_timeout";
export const REDIRECT_TIMEOUT_MESSAGE_LABEL = "ais_redirect_failed";
export const RETRY_LABEL = "ais_retry";
